import { Lang, Locale } from '@revolugo/common/constants'
import de from '@revolugo/design-system/locales/de/zod.json'
import en from '@revolugo/design-system/locales/en/zod.json'
import es from '@revolugo/design-system/locales/es/zod.json'
import fr from '@revolugo/design-system/locales/fr/zod.json'
import it from '@revolugo/design-system/locales/it/zod.json'
import nl from '@revolugo/design-system/locales/nl/zod.json'
import pt from '@revolugo/design-system/locales/pt/zod.json'

// eslint-disable-next-line @typescript-eslint/no-floating-promises
import('dayjs/locale/fr.js')
// eslint-disable-next-line @typescript-eslint/no-floating-promises
import('dayjs/locale/en.js')
// eslint-disable-next-line @typescript-eslint/no-floating-promises
import('dayjs/locale/de.js')
// eslint-disable-next-line @typescript-eslint/no-floating-promises
import('dayjs/locale/es.js')
// eslint-disable-next-line @typescript-eslint/no-floating-promises
import('dayjs/locale/it.js')
// eslint-disable-next-line @typescript-eslint/no-floating-promises
import('dayjs/locale/nl.js')
// eslint-disable-next-line @typescript-eslint/no-floating-promises
import('dayjs/locale/pt.js')

export default defineI18nConfig(() => ({
  fallbackLocale: Lang.EN,
  globalInjection: true,
  legacy: false,
  locale: Lang.EN,
  messages: {
    de,
    [Locale.de_DE]: de,
    en,
    [Locale.en_US]: en,
    es,
    [Locale.es_ES]: es,
    fr,
    [Locale.fr_FR]: fr,
    it,
    [Locale.it_IT]: it,
    nl,
    [Locale.nl_NL]: nl,
    pt,
    [Locale.pt_PT]: pt,
  },
}))
